import { Carousel } from 'antd';
import styled from 'styled-components';

interface CarouselWrapperProps {
  $alignItems?: string;
  $minHeight?: string;
  $arrowOffset?: string;
}

const CarouselWrapper = styled(Carousel)<CarouselWrapperProps>`
  .slick-dots {
    margin-top: 20px;
    position: relative;

    li {
      background: grey;

      &.slick-active::after {
        background: ${({ theme }) => `${theme.primaryColor}`};
      }

      :hover {
        opacity: 0.35 !important;
      }
    }
  }

  .slick-dots-bottom {
    bottom: 0;
  }

  .slick-prev {
    font-size: inherit;
    color: ${({ theme }) => `${theme.primaryColor}`};
    left: ${(props) => props.$arrowOffset ?? 'inherit'};
  }

  .slick-next {
    font-size: inherit;
    color: ${({ theme }) => `${theme.primaryColor}`};
    right: ${(props) => props.$arrowOffset ?? 'inherit'};
  }

  .slick-track {
    text-align: ${(props) => (props.$alignItems ? 'inherit' : 'center')};
    display: flex;
    align-items: ${(props) => props.$alignItems ?? 'center'};
    min-height: ${(props) => props.$minHeight ?? 'inherit'};
  }
`;

export default CarouselWrapper;
